module.exports = __webpack_public_path__ + "img/home_icon_geipaishui_sel.e06f1cb1.png";